import React from "react";
import { Avatar, Flex, H6, Small } from "orcs-design-system";
import { useOrgChartContext } from "src/components/OrgChart/context/OrgChartContext";
import { getName } from "src/util/person";
import PersonContactDetails from "src/components/PersonContactDetails";
import ReportsTo from "./components/ReportsTo";
import TagsEditor from "./components/TagsEditor";
import PersonDetails from "./components/PersonDetails";

const SelectedPerson = () => {
  const { state } = useOrgChartContext() || {};
  const selectedPerson =
    state?.loadedMembers?.[state?.expandedPanel?.data?.selectedEntity];

  if (!selectedPerson) {
    return (
      <Small color="greyDark">
        <em>
          No person selected, click on a person node to show information here.
        </em>
      </Small>
    );
  }

  return (
    <>
      <Flex flexDirection="column" alignItems="center" gap="s">
        <Avatar sizing="large" image={selectedPerson.avatar} />
        <H6 weight="bold">{getName(selectedPerson)}</H6>
        <Small color="greyDarker" fontWeight="600">
          {selectedPerson.jobTitle}
        </Small>
        <PersonContactDetails person={selectedPerson} />
      </Flex>
      <PersonDetails person={selectedPerson} />
      <TagsEditor />
      <ReportsTo person={selectedPerson} />
    </>
  );
};

export default SelectedPerson;
